import { DecisionIconType } from 'types/types';
import WhiteTick from './images/white-tick.svg';
import BlueTick from './images/blue-tick.svg';
import GreyTick from './images/grey-tick.svg';
import WhiteCross from './images/white-cross.svg';
import BlueCross from './images/blue-cross.svg';
import GreyCross from './images/grey-cross.svg';
import { toggleRmInvestigationOverlay } from 'slices/AppSlice';
import { updateRmInvestigation } from 'slices/RmSlice';
import styles from './StatsBar.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { selectRmInvestigationData } from 'selectors/selectors';
import PropTypes from 'prop-types';

const RmStatsCheckboxes = (props) => {
    const { index } = props;
    const dispatch = useDispatch();

    const [decisionContainerHoveredIndex, setDecisionContainerHoveredIndex] =
        useState(null);
    const [decisionContainerHoveredIcon, setDecisionContainerHoveredIcon] =
        useState(null);

    const investigationData = useSelector(selectRmInvestigationData);
    const { editable, rmInvestigations } = { ...investigationData };

    const getRmInvestigations = (scenario) => {
        return (
            rmInvestigations &&
            rmInvestigations.find((i) => i.scenario === scenario)
        );
    };

    const decideTickIconToDisplay = (idx) => {
        const rmInvestigation = getRmInvestigations(idx + 1);
        if (editable) {
            if (
                (decisionContainerHoveredIndex === idx &&
                    decisionContainerHoveredIcon === DecisionIconType.tick) ||
                (rmInvestigation &&
                    rmInvestigation.scenario === idx + 1 &&
                    rmInvestigation.isIncluded)
            ) {
                return WhiteTick;
            }
            return BlueTick;
        } else {
            if (
                rmInvestigation &&
                rmInvestigation.scenario === idx + 1 &&
                rmInvestigation.isIncluded
            ) {
                return WhiteTick;
            }
            return GreyTick;
        }
    };

    const decideCrossIconToDisplay = (idx) => {
        const rmInvestigation = getRmInvestigations(idx + 1);
        if (editable) {
            if (
                (decisionContainerHoveredIndex === idx &&
                    decisionContainerHoveredIcon === DecisionIconType.cross) ||
                (rmInvestigation &&
                    rmInvestigation.scenario === idx + 1 &&
                    rmInvestigation.isExcluded)
            ) {
                return WhiteCross;
            }
            return BlueCross;
        } else {
            if (
                rmInvestigation &&
                rmInvestigation.scenario === idx + 1 &&
                rmInvestigation.isExcluded
            ) {
                return WhiteCross;
            }
            return GreyCross;
        }
    };

    const decideContainerStyleBasedOnSelected = (scenario, decisionIcon) => {
        const investigation = getRmInvestigations(scenario);
        if (!investigation) return styles.decisionContainer;
        if (investigation.scenario === scenario) {
            if (decisionIcon === DecisionIconType.tick) {
                return investigation.isIncluded
                    ? styles.selectedDecisionContainer
                    : styles.decisionContainer;
            } else {
                return investigation.isExcluded
                    ? styles.selectedDecisionContainer
                    : styles.decisionContainer;
            }
        }
    };
    const handleContainerOnMouseOut = () => {
        setDecisionContainerHoveredIndex(null);
        setDecisionContainerHoveredIcon(null);
    };
    const handleDecisionContainerOnClick = (scenario, iconClicked) => {
        if (editable) {
            dispatch(toggleRmInvestigationOverlay());
            const investigation = getRmInvestigations(scenario);
            const doesScenarioMatch =
                investigation && investigation.scenario === scenario;
            const isTickIconSelected =
                doesScenarioMatch && investigation.isIncluded;
            const isCrossIconSelected =
                doesScenarioMatch && investigation.isExcluded;
            dispatch(
                updateRmInvestigation({
                    scenario,
                    isIncluded:
                        iconClicked === DecisionIconType.tick &&
                        !isTickIconSelected,
                    isExcluded:
                        iconClicked === DecisionIconType.cross &&
                        !isCrossIconSelected
                })
            );
        }
    };
    return (
        <>
            <div
                className={decideContainerStyleBasedOnSelected(
                    index + 1,
                    DecisionIconType.tick
                )}
                disabled={!editable}
                onClick={() =>
                    handleDecisionContainerOnClick(
                        index + 1,
                        DecisionIconType.tick
                    )
                }
                onMouseOver={() => {
                    setDecisionContainerHoveredIndex(index);
                    setDecisionContainerHoveredIcon(DecisionIconType.tick);
                }}
                onMouseOut={handleContainerOnMouseOut}
            >
                <img src={decideTickIconToDisplay(index)} alt={''} />
            </div>
            <div
                className={decideContainerStyleBasedOnSelected(
                    index + 1,
                    DecisionIconType.cross
                )}
                disabled={!editable}
                onClick={() =>
                    handleDecisionContainerOnClick(
                        index + 1,
                        DecisionIconType.cross
                    )
                }
                onMouseOver={() => {
                    setDecisionContainerHoveredIndex(index);
                    setDecisionContainerHoveredIcon(DecisionIconType.cross);
                }}
                onMouseOut={handleContainerOnMouseOut}
            >
                <img src={decideCrossIconToDisplay(index)} alt={''} />
            </div>
        </>
    );
};

RmStatsCheckboxes.propTypes = {
    index: PropTypes.number
};

export default RmStatsCheckboxes;
